import { ProSidebar, Menu, MenuItem, SubMenu, SidebarHeader, SidebarContent, SidebarFooter } from 'react-pro-sidebar';
import logo from "../../assets/images/logo-dark.png"

import { MdDashboard } from "react-icons/md"
import { FaUserCircle,FaCoins } from "react-icons/fa"
import { IoIosPeople } from "react-icons/io"
import { GiReceiveMoney } from "react-icons/gi"
import { FiLogOut } from "react-icons/fi"

import { Link } from 'react-router-dom'

import 'react-pro-sidebar/dist/css/styles.css';
import { logOutAction } from '../../redux/actions/authActions';
import "./custom.scss"
import * as PageUrl from '../../utils/pageUrl'

// eslint-disable-next-line
const ListArray = [
  {
    Icon: MdDashboard,
    title: "Overview",
    route: PageUrl.DASHBOARD
  },
  {
    Icon: FaCoins,
    title: "Sell Crypto",
    route: PageUrl.SELL
  },
  {
    Icon: FaUserCircle,
    title: "Profile",
    route: PageUrl.PROFILE
  },
  {
    Icon: GiReceiveMoney,
    title: "Transactions",
    route: PageUrl.TRANSACTIONS,
    // dropdownItems: [
    //   {
    //     Icon: MdDashboard,
    //     title: "All Transactions",
    //   },
    //   {
    //     Icon: MdDashboard,
    //     title: "Sort by Coin",
    //     route: "/dashboard/transactions/coin"
    //   },
    //   {
    //     Icon: FaUserCircle,
    //     title: "Sort by Status",
    //     route: "/dashboard/transactions/status"
    //   },
    // ]
  },
  {
    Icon: IoIosPeople,
    title: "Referrals",
    route: PageUrl.REFERRALS
  },

]

const ProNav = ({ collapsed, toggled, handleToggleSidebar }) => {

  return (
    // <div className={`fixed bg-white bottom-0 top-0 overflow-y-auto  text-black h-screen`}>
    <ProSidebar
      collapsed={collapsed}
      toggled={toggled}
      breakPoint="lg"
      onToggle={handleToggleSidebar}>
      <SidebarHeader>
        <Link to="/" className="block mx-auto">
          <img className="w-40 mx-auto py-6" src={logo} alt="logo" />
        </Link>
      </SidebarHeader>
      <SidebarContent>
        <Menu iconShape="round" popperArrow="true"
          className="capitalize">
          {/* <MenuItem icon={<MdDashboard />}
              onClick={() => handleToggleSidebar(false)}>
              Overview
              <Link to="/" />
            </MenuItem> */}


          {
            ListArray.map((item) => (
              !item.dropdownItems ?
                <MenuItem className="capitalize"
                  active={window.location.pathname === item.route}
                  key={item.title}
                  onClick={() => handleToggleSidebar(false)}
                  icon={<item.Icon />}>
                  {item.title}
                  <Link to={item.route} />
                </MenuItem> :
                <SubMenu key={item.title} title={item.title} icon={<item.Icon />}>
                  {
                    item.dropdownItems.map(item => (
                      <MenuItem className="capitalize" key={item.title}
                        onClick={() => handleToggleSidebar(false)}
                        active={window.location.pathname === item.route}
                      >
                        {item.title}
                        <Link to={item.route} />
                      </MenuItem>
                    ))
                  }

                </SubMenu>
            ))
          }



        </Menu>
      </SidebarContent>
      <SidebarFooter>
        <Menu>
          <MenuItem onClick={logOutAction} icon={<FiLogOut />}>
            Logout
            {/* <Link to="/login" /> */}
          </MenuItem>
        </Menu>
      </SidebarFooter>
    </ProSidebar>
    // </div >
  )
}

//   else {
//     return (
//       <Modal className="grid place-items-center h-screen">
//         <Loader />
//       </Modal>
//     )
//   }
// }

export default ProNav
